import React, { useState } from 'react';
import {
    PlusOutlined
} from '@ant-design/icons';
import {
    Button,
    Form,
    Input,
    Modal,
    message
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function AddFormModal() {

    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            axios
                .post('/api/brand/', data)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration:1,
                        onClose: () => form.resetFields()
                    });
                    queryClient.invalidateQueries(['/api/brand/'])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
        // onSuccess: () => {

        // },
        // onError: () => {
        // },
    });

    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate(values))
            .catch(err => {
                console.log(err)
                messageApi.open({
                    type: 'error',
                    content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                });
            })
    };

    const onCancelCreate = () => {
        form.resetFields();
        setOpen(false);
    }



    return (
        <div>
            {contextHolder}
            <Button
                type='primary'
                icon={<PlusOutlined />}
                onClick={() => setOpen(true)}
            >เพิ่ม</Button>
            <Modal
                open={open}
                title="เพิ่มแบรนด์สินค้า"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        ยกเลิก
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        ตกลง
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name='addBrand'
                >
                    <Form.Item
                        name="name"
                        label="แบรนด์"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกข้อมูล',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item name="description" label="รายละเอียด">
                        <Input type="textarea" />
                    </Form.Item>
                </Form>
            </Modal>
        </div>

    )
}
